import { axios } from '@/utils/axios';
import type {
  ExternalAuthCallbackResponse,
  ExternalProviderDescriptor,
  ExternalRegistrationRequest,
} from '@/types/externalAuth';

export const getExternalProviders = () =>
  axios.get<{ success: boolean; data: { providers: ExternalProviderDescriptor[] }; message: string }>(
    '/api/auth/external/providers'
  );

export const startExternalAuth = (
  provider: string,
  purpose: 'login' | 'register',
  returnPath?: string | null,
  turnstileToken?: string | null
) => axios.post<{ success: boolean; data: { authorization_url: string; expires_at: string }; message: string }>(
  `/api/auth/external/${encodeURIComponent(provider)}/start`,
  {
    purpose,
    ...(returnPath ? { return_path: returnPath } : {}),
    ...(turnstileToken ? { turnstile_token: turnstileToken } : {}),
  }
);

export const completeExternalAuth = (provider: string, data: Record<string, string>) =>
  axios.post<ExternalAuthCallbackResponse>(`/api/auth/external/${encodeURIComponent(provider)}/callback`, data);

export const completeExternalRegistration = (data: ExternalRegistrationRequest) =>
  axios.post<MemberSignInResponse>('/api/auth/external/registration/complete', data);
